import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface DebugState {
  enableLogging: boolean;
  disableAuthRedirect: boolean;
}

const loadFromStorage = (): DebugState => {
  const stored = localStorage.getItem("debug_settings");
  if (stored) {
    return JSON.parse(stored);
  }
  return {
    enableLogging: false,
    disableAuthRedirect: false,
  };
};

const initialState: DebugState = loadFromStorage();

const debugSlice = createSlice({
  name: "debug",
  initialState,
  reducers: {
    setEnableLogging: (state, action: PayloadAction<boolean>) => {
      state.enableLogging = action.payload;
      localStorage.setItem("debug_settings", JSON.stringify(state));
    },
    setDisableAuthRedirect: (state, action: PayloadAction<boolean>) => {
      state.disableAuthRedirect = action.payload;
      localStorage.setItem("debug_settings", JSON.stringify(state));
    },
  },
});

export const { setEnableLogging, setDisableAuthRedirect } = debugSlice.actions;
export const selectDebugSettings = (state: RootState) => state.debug;
export default debugSlice.reducer;
